export const getImageSRC = (image: { src: string } | string) =>
  typeof image === 'string' ? image : image.src;
